/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileSuggestionType } from './';
import {
    ProfileSuggestionTypeFromJSON,
    ProfileSuggestionTypeFromJSONTyped,
    ProfileSuggestionTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileSuggestion
 */
export interface ProfileSuggestion {
    /**
     * 
     * @type {ProfileSuggestionType}
     * @memberof ProfileSuggestion
     */
    type: ProfileSuggestionType;
    /**
     * Only present when type is MALT_PROJECT.
     * References the completed Malt project used to pre-fill the experience creation flow.
     * 
     * @type {string}
     * @memberof ProfileSuggestion
     */
    maltProjectId?: string;
}

/**
 * Check if a given object implements the ProfileSuggestion interface.
 */
export function instanceOfProfileSuggestion(value: object): value is ProfileSuggestion {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ProfileSuggestionFromJSON(json: any): ProfileSuggestion {
    return ProfileSuggestionFromJSONTyped(json, false);
}

export function ProfileSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ProfileSuggestionTypeFromJSON(json['type']),
        'maltProjectId': json['maltProjectId'] == null ? undefined : json['maltProjectId'],
    };
}

export function ProfileSuggestionToJSON(value?: ProfileSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': ProfileSuggestionTypeToJSON(value['type']),
        'maltProjectId': value['maltProjectId'],
    };
}

